export default function isImageSetPlusSized(imageSet) {
  const images = Array.isArray(imageSet) ? imageSet[0] : undefined;
  if (images) {
    const image = Array.isArray(images.sizes)
      ? images.sizes[0]?.url
      : undefined;
    if (image && typeof image === 'string') {
      return image.includes('plus');
    }
  }
  return false;
}
